<template>
  <div>
    <v-radio-group :row="!mobilePhone" v-model="modeRadio" @change="updateMode($event)" class="radio-btn-group">
      <v-radio color="primary" value="gop">
        <span slot="label" class="mode-label" style="color: #666;">
          Republican
        </span>
      </v-radio>
      <v-radio color="accent" value="dem">
        <span slot="label" class="mode-label" style="color: #666;">
          Democratic
        </span>
      </v-radio>
      <v-radio color="tertiary" value="god">
        <span slot="label" class="mode-label" style="color: #666;">Both Parties</span>
      </v-radio>
    </v-radio-group>
    <v-radio-group :row="!mobilePhone" v-model="chamberRadio" @change="updateChamber($event)" class="radio-btn-group">
      <v-radio color="primary" value="house">
        <span slot="label" class="mode-label" style="color: #666;">
          House
        </span>
      </v-radio>
      <v-radio color="primary" value="senate">
        <span slot="label" class="mode-label" style="color: #666;">
          Senate
        </span>
      </v-radio>
    </v-radio-group>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

const computed = {
  ...mapGetters({
    chamber: 'calculator/chamber',
    mode: 'calculator/mode'
  })
}

const methods = {
  ...mapActions({
    setChamber: 'calculator/setChamber',
    setMode: 'calculator/setMode',
    mobilePhone: 'ux/mobilePhone'
  }),
  updateMode (mode) {
    this.modeRadio = mode
    this.setMode(mode)
  },
  updateChamber (chamber) {
    this.chamberRadio = chamber
    this.setChamber(chamber)
  }
}

export default {
  computed,
  methods,
  data () {
    return {
      modeRadio: null,
      chamberRadio: null
    }
  },
  beforeMount () {
    this.modeRadio = this.mode
    this.chamberRadio = this.chamber
  }
}
</script>

<style>
.radio-btn-group {
  display: inline-block;
  vertical-align: top;
  max-width: 320px;
}

.mode-label {
  font-size: 0.9em;
  font-size: 600;
  letter-spacing: 0.1em;
  text-transform: uppercase;
}
</style>



// WEBPACK FOOTER //
// src/components/common/calculator/Mode.vue